import * as yup from 'yup';

export const validationSchema = yup.object().shape({
  email: yup.string().email('Value must be a valid email').required('Required'),
});
